function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('module/StartCaseStudy',[],function () {
  'use strict';

  /**
   * Modal class.
   * 
   * @author Lennart Bergmann <lb@sopg.de>
   * @jira CHEF-220
   * 
   * @created 2021-02-19
   * 
   * @type Modal
   */
  var StartCaseStudies = /*#__PURE__*/_createClass(
  /**
   * Constructor.
   * 
   * @author Lennart Bergmann <lb@sopg.de>
   * @created 2021-02-19
   * @updated 2021-02-26
   * 
   * @param {$} $slide 
   * @param {string} sModalClass 
   * @param {string} sModalButton = '.open-modal' 
   * 
   * @returns {undefined}
   */
  function StartCaseStudies($slide, sModalClass) {
    var _this = this;
    var sModalButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.open-modal';
    var fnOnCloseCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, StartCaseStudies);
    /**
     * Init
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-19
     * @updated 2021-02-26
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "init", function () {
      /* Add click listener. */
      $(_this.o.sel.caseButton).on('click', function (oEvent) {
        _this.$wrapper = $(oEvent.target).parents(_this.o.sel.caseContainer);
        _this.$bg = _this.$wrapper.find(_this.o.sel.bg);

        /* Set background-size: 100%, instead of cover. */
        _this.$bg.addClass('bg-size');

        /* Wait before setting zoom class. */
        setTimeout(function () {
          _this.$bg.addClass('zoom');
        }, 10);

        /* Go to next slide. */
        setTimeout(function () {
          window.onlineTraining.next();
        }, 1200);
        setTimeout(function () {
          _this.$bg.removeClass('zoom').removeClass('bg-size');
        }, 2000);
      });
    });
    this.o = {
      sel: {
        overlayWrapper: 'html',
        caseButton: '.js-start-case-study',
        caseContainer: '.case-study-wrapper',
        bg: '.wide-office-bg'
      },
      opt: {
        classes: {
          open: 'open',
          show: 'show'
        }
      }
    };
    this.init();
  });
  return StartCaseStudies;
});

